import React, { Component } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { FixedFooter, FixedHeader, LockerCells } from "../../../../reduxified"
import ErrorInfoModal from "../../../../Modals/ErrorInfoModal"
import LoadingInfoModal from "../../../../Modals/LoadingInfoModal"
import WaitingForLockerLock from "../../../../Modals/WaitingForLockerLock"
import WarningInfoModal from "../../../../Modals/WarningInfoModal"
import YesNoInfoModal from "../../../../Modals/YesNoInfoModal"
import {
  LogoutUser,
  reportFBEvent,
  logScreenEnterance,
  setLockerToLockerDeliveryOrder,
  confirmCreateOrder,
  openAndListenToSpecificLockerLock,
  resetLockersErrorsAttemptsOpened,
  setThankYouSubTitle,
  getOrderForPay,
  setLockerToLockerDeliveryOrderLoading,
  clearLtoLReducer,
  resetPaymentToTryAgain,
  //onCustomerL2LPutToLockerCancel,
  onCustomerL2LChangeLocker,
  onLoadingCustomerL2LChangeLocker,
  clearL2LChangeLocker,
  setDoNotInterrapt,
  setCanInterraptProcess,
} from "../../../../../actions"
import "./style.css"

class SelectLocker extends Component {
  constructor(props) {
    super(props)
    this.INIT_STATE = {
      isClickWaiting: false,
      isOpenedDoor: false,
      showContinueModal: false,
      isSelectAnotherCell: false,
      showPutToLockerCanceled: false,
      isCancelPutToCellSent: false,
      showIsShureToCancelPut: false,
      showEmptyAndCloseCell: false,
      showOrderConfirmFailModal: false,
      goOnWaiter: null,
      isWaitForCellChange: false,
      showLockerChangeError: false,
      lockerToCancel: null,
      nextLocker: null,
    }
    this.state = this.INIT_STATE
  }

  componentDidMount() {
    const { authenticated } = this.props
    if (!authenticated) {
      this.props.LogoutUser()
      this.props.history.push("")
    }
    this.props.logScreenEnterance("LOCKER_TO_LOCKER_DELIVERY SELECT_LOCKER")
    this.props.setDoNotInterrapt()
  }

  componentWillUnmount() {
    if (this.state.goOnWaiter) {
      clearTimeout(this.state.goOnWaiter)
    }
    this.props.setCanInterraptProcess()
  }

  componentWillReceiveProps(newProps) {
    const { authenticated, lockersData } = newProps

    if (!authenticated) {
      //add report
      this.props.reportFBEvent(
        "LOCKER_TO_LOCKER SELECT_LOCKER",
        "Not authenticated. Redirect to homepage."
      )
      this.props.LogoutUser()
      this.props.history.push("")
    }

    const {
      lockerWasClosed,
      openingErrorOccurred,
      openingDoorSuccess,
      payedOrder,
      createdOrder,
      isOrderConfirmed,
      isOrderConfirmFailed,
      lockersWithOpenStatusFromHw,
      isLoading,
      isCellChanged,
      isCellChangedError,
    } = newProps

    if (isOrderConfirmFailed) {
      this.setState({ showOrderConfirmFailModal: true })
      return
    }

    if (payedOrder == null && !isOrderConfirmed) {
      this.props.reportFBEvent(
        "LockerToLocker SelectLocker",
        "componentWillReceiveProps: The payedOrder is null. "
      )
      if (createdOrder) {
        console.log("Created Order " + createdOrder.orderNumber)
        //console.log("getOrderForPay " + createdOrder.orderNumber)
        //this.props.getOrderForPay(createdOrder.orderId)
      }
      return
    }

    if (
      openingErrorOccurred &&
      !this.state.isOpenedDoor //&& this.state.isWaitForCellChange === false
    ) {
      console.log("              componentWillReceiveProps:VI  DOOR ERROR")
      this.setState({ showDoorOpenErrorModal: true })
    }

    if (isLoading) {
      //clear out timer
      if (this.state.goOnWaiter) {
        clearTimeout(this.state.goOnWaiter)
      }
      //and wait
      console.log("isLoading - DO NOTHING")
      return
    }

    if (isCellChangedError) {
      this.setState({ showLockerChangeError: true })
      console.log(
        "              componentWillReceiveProps: show isCellChangedError"
      )
      return
    }

    if (openingDoorSuccess) {
      //console.log("Door OPENED")
      if (this.state.isOpenedDoor && !isOrderConfirmed) {
        //console.log("Door opened + order not confirmed (return)")
        return
      }

      if (this.state.nextLocker === null) {
        console.log(
          "              componentWillReceiveProps: openingDoorSuccess and nextLocker is null"
        )
        return
      }

      if (
        isOrderConfirmed &&
        this.state.isWaitForCellChange &&
        !isCellChanged &&
        !isCellChangedError
      ) {
        console.log(
          "              componentWillReceiveProps: door opened for replace"
        )
        this.setState({ isOpenedDoor: true, isWaitForCellChange: false })

        this.props.onLoadingCustomerL2LChangeLocker()
        this.props.onCustomerL2LChangeLocker(
          payedOrder.orderId,
          payedOrder.locationId,
          payedOrder.orderNumber,
          payedOrder.lockerNum
        )
        console.log("Locker change sent")

        return
      }

      if (isOrderConfirmed) {
        //console.log("       componentWillReceiveProps: Order confirmed DoorOpened   DO NOTHING")
        return
      }

      console.log(
        "       componentWillReceiveProps: first time DoorOpened for confirm"
      )
      this.setState({ isOpenedDoor: true })
      this.props.setLockerToLockerDeliveryOrderLoading()

      this.props.confirmCreateOrder({
        ...payedOrder,
        optionalWrongDoor: lockersWithOpenStatusFromHw.toString(),
      })
      console.log(
        "                         confirmCreateOrder " + payedOrder.orderNumber
      )
      return
    }

    //if (lockerWasClosed) {
    //console.log("       componentWillReceiveProps: lockerWasClosed")
    // }
    //
    if (this.state.nextLocker === null) {
      console.log(
        "              componentWillReceiveProps: openingDoorSuccess and nextLocker is null   DO NOTHING"
      )
      return
    }

    if (
      isCellChanged &&
      //!isOrderConfirmed && //TODO
      this.state.showIsShureToCancelPut === false &&
      this.state.showEmptyAndCloseCell === false &&
      this.state.showPutToLockerCanceled === false &&
      !this.state.isWaitForCellChange &&
      !isCellChangedError
    ) {
      console.log("       componentWillReceiveProps:I  RESET TIMEOUT TO OUT")
      this.setState({ isWaitForCellChange: false })
      this.resetTimeoutToContinue(500)
      return
    }

    if (
      isOrderConfirmed &&
      this.state.showIsShureToCancelPut === false &&
      this.state.showEmptyAndCloseCell === false &&
      this.state.showPutToLockerCanceled === false &&
      !this.state.isWaitForCellChange &&
      !isCellChangedError &&
      !isCellChanged
    ) {
      console.log("       componentWillReceiveProps:II  RESET TIMEOUT TO OUT")
      this.resetTimeoutToContinue(500)
    }

    if (!isLoading && this.state.showIsShureToCancelPut && isCellChangedError) {
      console.log("              componentWillReceiveProps: III   DO NOTHING")
      return
    }

    if (
      !openingErrorOccurred &&
      (this.state.showIsShureToCancelPut ||
        this.state.showEmptyAndCloseCell ||
        this.state.showPutToLockerCanceled ||
        this.state.isWaitForCellChange)
    ) {
      console.log("              componentWillReceiveProps:IV   DO NOTHING")
      return
    }

    if (
      !openingErrorOccurred &&
      lockerWasClosed //&& !this.state.isOpenedDoor
    ) {
      console.log("              componentWillReceiveProps:V  DO NOTHING")
      return
    }

    //if (
    //  openingErrorOccurred &&
    //  !this.state.isOpenedDoor //&& this.state.isWaitForCellChange === false
    //) {
    //  console.log("              componentWillReceiveProps:VI  DOOR ERROR")
    //  this.setState({ showDoorOpenErrorModal: true })
    //}
  }

  resetTimeoutToContinue(waitTime) {
    //console.log("*->   resetTimeoutToContinue")
    if (this.state.goOnWaiter) {
      clearTimeout(this.state.goOnWaiter)
      //this.props.reportFBEvent("LockerToLocker SelectLocker: ",
      //  `reset: clearTimeout.`)
    }
    this.props.reportFBEvent(
      "LockerToLocker SelectLocker: ",
      `reset: ${waitTime} setTimeout.`
    )
    this.setState({
      goOnWaiter: setTimeout(() => {
        this.props.reportFBEvent(
          "LockerToLocker SelectLocker: ",
          `${waitTime} Timeout function called.`
        )
        this.setState({ isOpenedDoor: false, nextLocker: null })
        clearTimeout(this.state.goOnWaiter)
        this.finishedGoContinue(this.props.lockersData)
      }, waitTime ?? 10000),
    })
  }

  finishedGoContinue(lockersData) {
    const {
      isWaitForCellChange,
      showIsShureToCancelPut,
      showEmptyAndCloseCell,
    } = this.state
    if (
      isWaitForCellChange ||
      showIsShureToCancelPut ||
      showEmptyAndCloseCell
    ) {
      this.props.reportFBEvent(
        "LockerToLocker SelectLocker: ",
        `finishedGoContinue aborted by new locker change.`
      )
      return
    }
    this.props.reportFBEvent(
      "LockerToLocker SelectLocker: ",
      `finishedGoContinue called.`
    )
    const haveEmpty = lockersData.filter(
      (locker) => locker.lockerStatus === 3 && !locker.order
    ).length

    if (haveEmpty > 1) {
      this.setState({ showContinueModal: true })
    } else {
      this.props.setThankYouSubTitle(this.props.see_you_again)
      this.props.history.push("/ThankYouScreen")
    }
  }

  checkIsWaiting() {
    if (this.state.isCellClickWaiting) {
      return true
    }
    return false
  }

  isWaiting(wait) {
    if (wait && this.state.isCellClickWaiting) {
      return true
    }

    let { timeO } = this.state

    timeO = wait
      ? setTimeout((num) => {
          this.isWaiting(num, false)
        }, 2000)
      : clearTimeout(timeO)

    this.setState({
      ...this.state,
      isCellClickWaiting: wait,
      timeO: timeO,
    })

    return wait
  }

  async onCellClick(cellNum, lockerData) {
    if (lockerData == undefined) {
      console.log("onCellClick: lockerData == undefined")
      return
    }

    const { disabled } = lockerData
    if (disabled) {
      console.log("onCellClick: lockerData : if disabled")
      return
    }
    const { isLoading, isOrderConfirmed, stationId } = this.props
    if (isLoading && !this.state.isSelectAnotherCell) {
      console.log("onCellClick: isLoading :" + isLoading)

      return
    }

    if (this.checkIsWaiting()) {
      console.log("onCellClick: isCellClickWaiting")
      return
    }

    if (
      isOrderConfirmed &&
      !this.state.isSelectAnotherCell &&
      !this.state.isWaitForCellChange
    ) {
      console.log("onCellClick: isOrderConfirmed:" + isOrderConfirmed)
      return
    }

    if (this.state.goOnWaiter) {
      clearTimeout(this.state.goOnWaiter)
    }

    console.log("*->  onCellClick")
    this.setState({
      isSelectAnotherCell: false,
      isOpenedDoor: false,
      showContinueModal: false,
    })

    // IF payedOrder, createdOrder IS NULL - LOGOUT
    let { payedOrder, createdOrder } = this.props
    if (!payedOrder) {
      this.props.reportFBEvent(
        "LockerToLocker SelectLocker",
        "onCellClick: The payedOrder is null. "
      )
      if (!createdOrder) {
        this.props.reportFBEvent(
          "LockerToLocker SelectLocker",
          "onCellClick: The payedOrder and createdOrder is null. Redirect homepage."
        )
        console.log("      onCellClick: !createdOrder >> GO OUT!")
        this.props.LogoutUser()
        this.props.history.push("")
      }
      return
    }
    /////////////////////////////////////////////////
    this.props.reportFBEvent(
      "LockerToLocker SelectLocker",
      `onCellClick: Set locker${cellNum}(${lockerData.lockerId}) to payedOrder(${payedOrder?.orderNumber}). `
    )
    payedOrder.lockerNum = cellNum
    payedOrder.locationId = lockerData.lockerId
    const { stationPaymentVersion } = this.props
    await this.props.setLockerToLockerDeliveryOrder(payedOrder)
    await this.props.openAndListenToSpecificLockerLock(
      cellNum,
      undefined, //attempts
      stationId,
      undefined, //packageNumber
      2, //it's lockerStatus (2 means 'full', 3 means 'empty')
      stationPaymentVersion
    )
    this.isWaiting(cellNum, true)

    this.setState({
      lockerToCancel: { name: cellNum, id: lockerData.lockerId },
      nextLocker: { name: cellNum, id: lockerData.lockerId },
    })
  }

  onDoorOpenErrModalClose() {
    console.log("*->  onDoorOpenErrModalClose")
    this.setState({
      showDoorOpenErrorModal: false,
      clickedLocker: null,
      //isCellClickWaiting: false,
    })
    this.props.resetLockersErrorsAttemptsOpened()
  }

  onOopsClicked() {
    const { isSelectAnotherCell } = this.state
    console.log(
      "*->  onOopsClicked  ---  isSelectAnotherCell:" + isSelectAnotherCell
    )
    const { payedOrder } = this.props

    if (isSelectAnotherCell === true) {
      this.setState({
        isCellClickWaiting: false,
      })
      console.log(
        "       onOopsClicked: isSelectAnotherCell==true, set isCellClickWaiting=false return"
      )
      return
    }

    /*this.props.setLockerToLockerDeliveryOrderLoading()
    this.props.onCustomerL2LPutToLockerCancel(
      this.props.payedOrder?.orderId,
      this.props.payedOrder?.locationId
    )

    this.props.reportFBEvent(
      "LockerToLocker SelectLocker: ",
      "Sent CANCEL PUT TO LOCKER " +
        payedOrder.lockerNum +
        " ORDER " +
        payedOrder.orderNumber +
        "."
    )*/

    this.setState({
      isCellClickWaiting: false,
      isSelectAnotherCell: true,
      isCancelPutToCellSent: false,
      isClickWaiting: false,
      showContinueModal: false,
      selectedOrderId: payedOrder?.orderId,
      isWaitForCellChange: true,
      nextLocker: null,
    })
    this.props.clearL2LChangeLocker()
    if (this.state.goOnWaiter) {
      clearTimeout(this.state.goOnWaiter)
    }
    console.log("       onOopsClicked: clearL2LChangeLocker")
  }

  closePutToLockerCanceledModal() {
    console.log("*-> closePutToLockerCanceledModal")
    this.setState({
      showPutToLockerCanceled: false,
      isOpenedDoor: false,
      nextLocker: this.state.lockerToCancel,
    })
  }

  render() {
    const {
      blinkers,
      errLockers,
      opening_locker_number,
      waitingForLockerLockTitle,
      pls_close_door,
      err_while_opening_door,
      try_another_locker_or_contact_support,
      close_text,
      please_wait,
      openingDoorSuccess,
      openAttemptsNum,
      dirRtl,
      payedOrder,
      choose_locker,
      want_to_place_another_order,
      yes_text,
      no_text,
      see_you_again,
      select_another_cell,
      put_to_locker_canceled_title,
      put_to_locker_canceled_body,
      canceling_put_to_locker,
      are_you_shure,
      please_empty_and_close_the_cell,
      closing_door_is_not_recognized_click_here,
      barcode_text,
      //back_to_start_l2l,
      isLoading,
      error_on_change_locker,
      try_again_connect_support,
      action_is_failed,
      isCellChangedError,
    } = this.props

    const {
      showDoorOpenErrorModal,
      showContinueModal,
      showPutToLockerCanceled,
      showIsShureToCancelPut,
      showEmptyAndCloseCell,
      showOrderConfirmFailModal,
      showLockerChangeError,
    } = this.state

    let { lockerNum } = 11111
    if (
      payedOrder &&
      payedOrder.lockerNum != undefined &&
      payedOrder.lockerNum != null
    ) {
      lockerNum = payedOrder.lockerNum
    }

    if (openingDoorSuccess) {
      //console.log("must show door opening")
    }

    return (
      <>
        <div className="ls-wrapper ">
          <FixedHeader buttonsFlag="unlockLockersScreen" />
          <div className="rent-locker-title">{choose_locker}</div>

          <div className="ddocs-inner-wrapper">
            <LockerCells
              onCellClick={this.onCellClick.bind(this)}
              blinkers={blinkers}
              errLockers={errLockers}
              hideInfo={true}
              lockerToLockerDelivery={true}
            />
          </div>
          <FixedFooter history={this.props.history} />
        </div>
        <YesNoInfoModal
          dirRtl={dirRtl}
          show={showContinueModal}
          title={want_to_place_another_order}
          onModalOkClick={async () => {
            await this.props.clearLtoLReducer()
            await this.props.resetPaymentToTryAgain()
            this.props.history.push("/LockerToLockerDeliveryScreen/Menu")
          }}
          onModalCancelClick={() => {
            this.setState({ showContinueModal: false })
            this.props.setThankYouSubTitle(see_you_again)
            this.props.history.push("/ThankYouScreen")
          }}
          okTransl={yes_text}
          cancelTransl={no_text}
        />

        <LoadingInfoModal
          dirRtl={dirRtl}
          show={
            openAttemptsNum > 0 &&
            !showDoorOpenErrorModal &&
            !showLockerChangeError &&
            !showOrderConfirmFailModal
          }
          title={opening_locker_number.replace("{XYZ}", lockerNum)}
          text={please_wait}
        />

        {/*
          <LoadingInfoModal
            dirRtl={dirRtl}
            show={openAttemptsNum > 0 && !showDoorOpenErrorModal}
            title={opening_locker_number.replace("{XYZ}", lockerNum)}
            text={please_wait}
            onOopsClicked={async () => {
              this.props.reportFBEvent(
                "LockerToLocker SelectLocker: ",
                "WAITING FOR DOOR " +
                  lockerNum +
                  " opened: Clicked back to START for (order " +
                  payedOrder.orderNumber +
                  ")."
              )
              await this.props.clearLtoLReducer()
              await this.props.resetPaymentToTryAgain()
              this.props.history.push("/LockerToLockerDeliveryScreen/Menu")
            }}
            oopsButtonText={back_to_start_l2l}
          />
        */}

        <WaitingForLockerLock
          dirRtl={dirRtl}
          show={openingDoorSuccess}
          title={waitingForLockerLockTitle.replace("{XYZ}", lockerNum)}
          subTitle={pls_close_door}
          onOopsClicked={() => {
            if (this.state.goOnWaiter) {
              clearTimeout(this.state.goOnWaiter)
              this.setState({
                goOnWaiter: false,
              })
            }
            this.setState({
              showIsShureToCancelPut: true,
            })
            this.props.reportFBEvent(
              "LockerToLocker SelectLocker:",
              "AFTER DOOR " +
                payedOrder.lockerNum +
                " OPENED, clicked CHANGE LOCKER for order " +
                payedOrder.orderNumber +
                "."
            )
          }}
          cancelText={select_another_cell}
          isLoading={isLoading || isCellChangedError}
          isSelectAnotherCellClicked={this.state.isSelectAnotherCell}
          notRecognizedCloseText={closing_door_is_not_recognized_click_here}
          barcodeTitle={barcode_text}
        />
        <ErrorInfoModal
          dirRtl={dirRtl}
          show={showDoorOpenErrorModal}
          title={err_while_opening_door}
          text={try_another_locker_or_contact_support.replace(
            "{XYZ}",
            lockerNum
          )}
          onModalCloseClick={() => this.onDoorOpenErrModalClose()}
          closeTrnsl={close_text}
        />

        <ErrorInfoModal
          dirRtl={dirRtl}
          show={showOrderConfirmFailModal}
          title={action_is_failed}
          text={try_again_connect_support}
          onModalCloseClick={async () => {
            this.props.reportFBEvent(
              "LockerToLocker SelectLocker: ",
              "Order confirm is FAILED!!!  Opened locker: " +
                lockerNum +
                " order: " +
                payedOrder.orderNumber +
                "."
            )

            await this.props.clearLtoLReducer()
            await this.props.resetPaymentToTryAgain()
            this.props.history.push("/LockerToLockerDeliveryScreen/Menu")
          }}
          closeTrnsl={close_text}
        />

        <WarningInfoModal
          show={showPutToLockerCanceled}
          title={put_to_locker_canceled_title + lockerNum}
          text={put_to_locker_canceled_body}
          onModalCloseClick={() => this.closePutToLockerCanceledModal()}
          btnText={close_text}
          isLoading={isLoading}
        />
        <YesNoInfoModal
          show={showIsShureToCancelPut}
          title={canceling_put_to_locker + lockerNum}
          text={are_you_shure}
          onModalOkClick={(e) => {
            this.setState({
              showIsShureToCancelPut: false,
              showEmptyAndCloseCell: true,
              showContinueModal: false,
            })
          }}
          onModalCancelClick={(e) => {
            this.props.reportFBEvent(
              "LockerToLocker SelectLocker: ",
              `IsShureToCancelPut: clicked CANCEL CHANGE LOCKER ${payedOrder.lockerNum} for order ${payedOrder.orderNumber}.`
            )

            this.setState({
              showIsShureToCancelPut: false,
              isWaitForCellChange: false,
            })

            this.props.reportFBEvent(
              "LockerToLocker SelectLocker: ",
              `IsShureToCancelPut: clicked CANCEL call resetTimeoutToContinue(500).`
            )

            this.resetTimeoutToContinue(500)
          }}
          okTransl={yes_text}
          cancelTransl={no_text}
          dirRtl={this.props.dirRtl}
          noResponceForOuterClick={true}
        />
        <WarningInfoModal
          show={showEmptyAndCloseCell}
          title={""}
          text={please_empty_and_close_the_cell + lockerNum}
          onModalCloseClick={() => {
            this.setState({
              showEmptyAndCloseCell: false,
              showContinueModal: false,
            })
            this.props.reportFBEvent(
              "LockerToLocker SelectLocker",
              "Empty-and-Close-Cell " + lockerNum + " message CLICKED."
            )
            this.onOopsClicked()
          }}
          btnText={close_text}
          isLoading={isLoading}
        />

        <WarningInfoModal
          show={this.state.showLockerChangeError}
          title={error_on_change_locker + lockerNum}
          text={try_again_connect_support}
          onModalCloseClick={() => {
            this.setState({ showLockerChangeError: false })

            this.props.reportFBEvent(
              "LockerToLocker SelectLocker",
              "Clicked OK after server ERROR on change locker " +
                payedOrder.lockerNum +
                " to order " +
                payedOrder.orderNumber +
                "."
            )
            this.onOopsClicked()
          }}
          btnText={close_text}
        />
      </>
    )
  }
}

const mapStateToProps = ({
  userLogin,
  lockersCells,
  translate,
  bgService,
  lockerToLockerDelivery,
  stationServiceTypes,
}) => {
  const { stationPaymentVersion } = stationServiceTypes

  const { authenticated, role, userId } = userLogin
  const {
    openedLockersArr,
    errorLockersArr,
    openingAttempsMap,
    recentClosedLockersArr,
    brokenLockersNumArr,
    lockersWithOpenStatusFromHw,
    lockersData,
  } = lockersCells
  const {
    dirRtl,
    driver_menu_lockers_cells_opening,
    driver_lockers_cells_opening_subtitle,
    please_wait,
    opening_locker_number,
    on_order_collection_finish,
    pls_close_door,
    try_another_locker_or_contact_support,
    err_while_opening_door,
    close_text,
    choose_locker,
    yes_text,
    no_text,
    see_you_again,
    want_to_place_another_order,
    select_another_cell,
    put_to_locker_canceled_title,
    put_to_locker_canceled_body,
    canceling_put_to_locker,
    are_you_shure,
    please_empty_and_close_the_cell,
    closing_door_is_not_recognized_click_here,
    barcode_text,
    //back_to_start_l2l,
    error_on_change_locker,
    try_again_connect_support,
    action_is_failed,
    at_action_end,
  } = translate

  const waitingForLockerLockTitle = `${opening_locker_number}. ${at_action_end}`

  const { stationId } = bgService
  const {
    payedOrder,
    createdOrder,
    isLoading,
    isOrderConfirmed,
    isOrderConfirmFailed,
    isCellChanged,
    isCellChangedError,
  } = lockerToLockerDelivery

  const { lockerNum } = payedOrder || {}
  const openingDoorSuccess = openedLockersArr.includes(lockerNum)
  const openingErrorOccurred = errorLockersArr.includes(lockerNum)
  const lockerWasClosed = recentClosedLockersArr.includes(lockerNum)
  const openAttemptsNum = openingAttempsMap[lockerNum] || 0
  const blinkers = !openingErrorOccurred ? { [lockerNum]: lockerNum } : {}
  const errLockers = openingErrorOccurred ? { [lockerNum]: lockerNum } : {}

  return {
    stationPaymentVersion,
    authenticated,
    role,
    userId,
    blinkers,
    errLockers,
    openingDoorSuccess,
    openingErrorOccurred,
    lockerWasClosed,
    openAttemptsNum,
    driver_menu_lockers_cells_opening,
    driver_lockers_cells_opening_subtitle,
    opening_locker_number,
    stationId,
    payedOrder,
    createdOrder,
    brokenLockersNumArr,
    lockersWithOpenStatusFromHw,
    dirRtl,
    please_wait,
    waitingForLockerLockTitle,
    pls_close_door,
    try_another_locker_or_contact_support,
    err_while_opening_door,
    close_text,
    isLoading,
    isOrderConfirmed,
    isOrderConfirmFailed,
    choose_locker,
    yes_text,
    no_text,
    see_you_again,
    want_to_place_another_order,
    lockersData,
    select_another_cell,
    put_to_locker_canceled_title,
    put_to_locker_canceled_body,
    canceling_put_to_locker,
    are_you_shure,
    please_empty_and_close_the_cell,
    closing_door_is_not_recognized_click_here,
    barcode_text,
    //back_to_start_l2l,
    isCellChanged,
    isCellChangedError,
    error_on_change_locker,
    try_again_connect_support,
    action_is_failed,
  }
}

export default connect(mapStateToProps, {
  LogoutUser,
  reportFBEvent,
  logScreenEnterance,
  setLockerToLockerDeliveryOrder,
  confirmCreateOrder,
  openAndListenToSpecificLockerLock,
  resetLockersErrorsAttemptsOpened,
  setThankYouSubTitle,
  getOrderForPay,
  setLockerToLockerDeliveryOrderLoading,
  clearLtoLReducer,
  resetPaymentToTryAgain,
  //onCustomerL2LPutToLockerCancel,
  onCustomerL2LChangeLocker,
  onLoadingCustomerL2LChangeLocker,
  clearL2LChangeLocker,
  setDoNotInterrapt,
  setCanInterraptProcess,
})(withRouter(SelectLocker))
